import React, { useRef, useState, useEffect } from "react";
import { Image, Card, Row, Col, Carousel, Button } from "antd";
import { LeftOutlined, RightOutlined } from "@ant-design/icons";
import { isMobile } from "react-device-detect";
import GooglePhotosAlbum from "./GooglePhotosAlbum";
import ElfsightGallery from "./ElfsightGallery";
import { Navigation } from "./navigation";

const { Meta } = Card;
const slides = [
  {
    slideData: [
      {
        "title": "Project Title",
        "largeImage": "img/portfolio/01-large.jpg",
        "smallImage": "img/portfolio/01-small.jpg"
      },
      {
        "title": "Project Title",
        "largeImage": "img/portfolio/02-large.jpg",
        "smallImage": "img/portfolio/02-small.jpg"
      },
      {
        "title": "Project Title",
        "largeImage": "img/portfolio/03-large.jpg",
        "smallImage": "img/portfolio/03-small.jpg"
      },
      {
        "title": "Project Title",
        "largeImage": "img/portfolio/04-large.jpg",
        "smallImage": "img/portfolio/04-small.jpg"
      },
      {
        "title": "Project Title",
        "largeImage": "img/portfolio/05-large.jpg",
        "smallImage": "img/portfolio/05-small.jpg"
      },
      {
        "title": "Project Title",
        "largeImage": "img/portfolio/06-large.jpg",
        "smallImage": "img/portfolio/06-small.jpg"
      },
      {
        "title": "Project Title",
        "largeImage": "img/portfolio/07-large.jpg",
        "smallImage": "img/portfolio/07-small.jpg"
      },
      {
        "title": "Project Title",
        "largeImage": "img/portfolio/08-large.jpg",
        "smallImage": "img/portfolio/08-small.jpg"
      },
      {
        "title": "Project Title",
        "largeImage": "img/portfolio/09-large.jpg",
        "smallImage": "img/portfolio/09-small.jpg"
      },
      {
        "title": "Project Title",
        "largeImage": "img/portfolio/03-large.jpg",
        "smallImage": "img/portfolio/03-small.jpg"
      },
      {
        "title": "Project Title",
        "largeImage": "img/portfolio/04-large.jpg",
        "smallImage": "img/portfolio/04-small.jpg"
      },
      {
        "title": "Project Title",
        "largeImage": "img/portfolio/05-large.jpg",
        "smallImage": "img/portfolio/05-small.jpg"
      },
    ]
  },
  {
    slideData: [
      {
        "title": "Project Title",
        "largeImage": "img/portfolio/01-large.jpg",
        "smallImage": "img/portfolio/01-small.jpg"
      },
      {
        "title": "Project Title",
        "largeImage": "img/portfolio/02-large.jpg",
        "smallImage": "img/portfolio/02-small.jpg"
      },
      {
        "title": "Project Title",
        "largeImage": "img/portfolio/03-large.jpg",
        "smallImage": "img/portfolio/03-small.jpg"
      },
      {
        "title": "Project Title",
        "largeImage": "img/portfolio/04-large.jpg",
        "smallImage": "img/portfolio/04-small.jpg"
      },
      {
        "title": "Project Title",
        "largeImage": "img/portfolio/05-large.jpg",
        "smallImage": "img/portfolio/05-small.jpg"
      },
      {
        "title": "Project Title",
        "largeImage": "img/portfolio/06-large.jpg",
        "smallImage": "img/portfolio/06-small.jpg"
      },
      {
        "title": "Project Title",
        "largeImage": "img/portfolio/07-large.jpg",
        "smallImage": "img/portfolio/07-small.jpg"
      },
      {
        "title": "Project Title",
        "largeImage": "img/portfolio/08-large.jpg",
        "smallImage": "img/portfolio/08-small.jpg"
      },
      {
        "title": "Project Title",
        "largeImage": "img/portfolio/09-large.jpg",
        "smallImage": "img/portfolio/09-small.jpg"
      },
      {
        "title": "Project Title",
        "largeImage": "img/portfolio/03-large.jpg",
        "smallImage": "img/portfolio/03-small.jpg"
      },
      {
        "title": "Project Title",
        "largeImage": "img/portfolio/04-large.jpg",
        "smallImage": "img/portfolio/04-small.jpg"
      },
      {
        "title": "Project Title",
        "largeImage": "img/portfolio/05-large.jpg",
        "smallImage": "img/portfolio/05-small.jpg"
      },
    ]
  },

]
export const Gallery = () => {
  const carouselRef = useRef(null);
  const [isPreviewOpen, setIsPreviewOpen] = useState(false);

  // Disable keyboard arrow navigation for Carousel when preview is open
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (isPreviewOpen) {
        // Stop carousel navigation when preview is open
        e.stopPropagation();
      } else {
        if (e.key === "ArrowLeft") {
          carouselRef.current?.prev();
        } else if (e.key === "ArrowRight") {
          carouselRef.current?.next();
        }
      }
    };

    window.addEventListener("keydown", handleKeyDown, true);
    return () => window.removeEventListener("keydown", handleKeyDown, true);
  }, [isPreviewOpen]);

  return (
    <>
      <Navigation />
      <div
        id="newsection"
        style={{
          display: "flex",
          justifyContent: "center",
          padding: "40px 20px",
          minHeight: "700px",
          position: "relative",
          overflow: "hidden",
        }}
      >
        <Row align="middle" style={{ width: "100%" }}>
          <Col span={24}>
            <div className="section-title" style={{ textAlign: "center", marginBottom: "24px" }}>
              <h2>Gallery</h2>
            </div>
            {/* <Card
            className="gallerycarouselcard"
            style={{ width: "100%",maxHeight:isMobile?'auto':'500px' }}
          >
            <div style={{ position: "relative" }}>
              <div
                style={{
                  display: isMobile ? "none" : "flex",
                  justifyContent: "center",
                  marginTop: isMobile ? "10px" : "0",
                  position: isMobile ? "static" : "absolute",
                  width: "100%",
                  top: isMobile ? "auto" : "50%",
                }}
              >
              <LeftOutlined
                                onClick={() => carouselRef.current?.prev()}
                                style={{
                                  fontSize: "24px",
                                  color: "#fff",
                                  cursor: "pointer",
                                  zIndex: 10,
                                  background: "rgba(0,0,0,0.5)",
                                  padding: "10px",
                                  borderRadius: "50%",
                                  margin: isMobile ? "0 10px" : "0",
                                  position: isMobile ? "static" : "absolute",
                                  left: isMobile ? "auto" : "100px",
                                }}
                              />
                              <RightOutlined
                                onClick={() => carouselRef.current?.next()}
                                style={{
                                  fontSize: "24px",
                                  color: "#fff",
                                  cursor: "pointer",
                                  zIndex: 10,
                                  background: "rgba(0,0,0,0.5)",
                                  padding: "10px",
                                  borderRadius: "50%",
                                  margin: isMobile ? "0 10px" : "0",
                                  position: isMobile ? "static" : "absolute",
                                  right: isMobile ? "auto" : "100px",
                                }}
                              />
              
            </div>
            <Carousel ref={carouselRef} arrows={false} dots={true}>
              {slides.map((slide, index) => (
                <div
                  key={index}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    flexDirection: "column",
                    minHeight: "400px",
                  }}
                >
                  <Image.PreviewGroup
                    preview={{
                      onVisibleChange: (visible) => setIsPreviewOpen(visible),
                    }}
                  >
                    <Row gutter={[16, 16]} justify="center">
                      {slide?.slideData?.map((d, i) => (
                        <Col key={`${d.title}-${i}`} xs={24} sm={12} md={8} lg={4}>
                          <Card hoverable className="gallerycard">
                            <Image
                              alt={d.title}
                              src={d.smallImage}
                              preview={{ src: d.largeImage }}
                              style={{ borderRadius: "7px" }}
                            />
                          </Card>
                        </Col>
                      ))}
                    </Row>
                  </Image.PreviewGroup>
                </div>
              ))}
            </Carousel>
          </div>
        </Card> */}
            <div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
              {/* <iframe
        src="https://photos.app.goo.gl/ir6n9vu7jDtrV9b89"
        frameBorder="0"
        width="960"
        height="569"
        allowFullScreen
        title="Google Photos Gallery"
      ></iframe> */}
              <ElfsightGallery />
            </div>

          </Col>
        </Row>
      </div >
    </>

  );
};
